"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageTitle;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _ArrowBackIcon;
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    container: {
      width: 'auto',
      wordBreak: 'break-all'
    },
    root: {
      display: 'flex',
      lineHeight: 1,
      marginBottom: theme.spacing(2),
      minHeight: 56
    },
    subtitle: {
      color: theme.palette.text.disabled
    },
    titleActions: {
      '& > button, & > a': {
        margin: theme.spacing(0.5)
      },
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      margin: "".concat(theme.spacing(-0.5), " ").concat(theme.spacing(-0.5), " ").concat(theme.spacing(-0.5), " auto")
    }
  };
});
function PageTitle(_ref) {
  var actions = _ref.actions,
    afterTitleComponents = _ref.afterTitleComponents,
    back = _ref.back,
    _ref$BackComponent = _ref.BackComponent,
    BackComponent = _ref$BackComponent === void 0 ? _material.IconButton : _ref$BackComponent,
    _ref$BackComponentPro = _ref.BackComponentProps,
    BackComponentProps = _ref$BackComponentPro === void 0 ? {
      component: _reactRouterDom.Link
    } : _ref$BackComponentPro,
    backPath = _ref.backPath,
    className = _ref.className,
    id = _ref.id,
    subtitle = _ref.subtitle,
    title = _ref.title,
    titleKey = _ref.titleKey;
  var classes = useStyles();
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    pathname = _useLocation.pathname;
  var pathArray = pathname.replace(/\/+$/, '').split('/');
  pathArray.pop();
  var backUrl = backPath || pathArray.join('/');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, className),
    id: id
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    container: true,
    justifyContent: "space-between",
    spacing: 1,
    wrap: "wrap"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.container,
    container: true,
    item: true,
    wrap: "nowrap"
  }, back && backUrl && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(BackComponent, (0, _extends2.default)({
    id: "".concat(id, "BackButton"),
    to: {
      pathname: backUrl,
      state: {
        isBack: true
      }
    }
  }, BackComponentProps), _ArrowBackIcon || (_ArrowBackIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.ArrowBack, null)))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    className: classes.container,
    container: true,
    item: true,
    spacing: 1,
    wrap: "wrap"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: "".concat(id, "Title"),
    variant: "h5"
  }, title || /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: titleKey
  })), subtitle && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.subtitle,
    id: "".concat(id, "Subtitle"),
    variant: "caption"
  }, subtitle)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    id: "".concat(id, "AfterTitleComponents"),
    item: true
  }, afterTitleComponents))), actions && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.titleActions,
    id: "".concat(id, "Actions"),
    item: true
  }, actions)));
}